// extracted by mini-css-extract-plugin
module.exports = {"hidden":"recommend_hidden__tblaB","textEmphasis":"recommend_textEmphasis__T8tby","titleArea":"recommend_titleArea__GPDK2"};